import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PromotionBanners from './PromotionBanners';
import { getPromotionBanners } from '../../store/actions/general.actions';
import { Translate } from '../../localization';

function Promotion() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getPromotionBanners());
        const canonicalTag = document.querySelector('link[rel="canonical"]');
        if (canonicalTag) {
            canonicalTag.setAttribute(
                'href',
                `https://www.jackpotct.com/${Translate.getLanguage()}/d/promotion`
            );
        }
    }, []);

    useEffect(() => {
        document.title = `Exciting Promotions at Jackpot Casino`;
        const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        `Discover thrilling promotions and lucrative bonuses at
        JackpotCT. Play your favorite online casino games and
        win big with our exclusive offers.`
      );
    }

      }, []);

    return (
        <React.Fragment>
            <div id='scrollableDiv' className="d-flex">
                <PromotionBanners />
            </div>
        </React.Fragment>
    );
}


export default Promotion;
